import { Stack } from "@mui/material";
import AllPackagesSection from "@/components/online-store/packages/allPackagesSection";
import FeaturedDealsSection from "@/components/online-store/packages/featuredDealsSection";
import { isPackageFeatured } from "@/utils/packages";
import { MedspaPackage } from "@/views/online-store/onlineStoreView";

type Props = {
  packages: MedspaPackage[];
  customizationPrimaryColor: string;
  featuredDealsSectionEnabled: boolean;
  customizationEnabled: boolean;
  medspaId: string;
  setIsCheckoutDrawerOpen: (isOpen: boolean) => void;
  packageCardRevampV1Enabled: boolean;
};

export default function OnlineStorePackagesContainer({
  packages,
  customizationPrimaryColor,
  featuredDealsSectionEnabled,
  customizationEnabled,
  medspaId,
  setIsCheckoutDrawerOpen,
  packageCardRevampV1Enabled,
}: Props) {
  const featuredDealPackages = featuredDealsSectionEnabled
    ? packages.filter((packageItem) => isPackageFeatured(packageItem?.endDate))
    : [];

  const hasFeaturedDeals = featuredDealPackages.length > 0;

  return (
    <Stack>
      {hasFeaturedDeals && (
        <FeaturedDealsSection
          packages={featuredDealPackages}
          customizationPrimaryColor={customizationPrimaryColor}
          medspaId={medspaId}
          customizationEnabled={customizationEnabled}
          setIsCheckoutDrawerOpen={setIsCheckoutDrawerOpen}
          packageCardRevampV1Enabled={packageCardRevampV1Enabled}
        />
      )}

      <AllPackagesSection
        packages={packages}
        customizationEnabled={customizationEnabled}
        customizationPrimaryColor={customizationPrimaryColor}
        medspaId={medspaId}
        labelSx={!hasFeaturedDeals && { mt: 3 }}
        setIsCheckoutDrawerOpen={setIsCheckoutDrawerOpen}
        packageCardRevampV1Enabled={packageCardRevampV1Enabled}
      />
    </Stack>
  );
}
